import { render, staticRenderFns } from "./PdpProductWarehouses.vue?vue&type=template&id=64dbe385&"
import script from "./PdpProductWarehouses.vue?vue&type=script&lang=js&"
export * from "./PdpProductWarehouses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports